import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-custom-input-time',
    templateUrl: './custom-input-time.component.html',
    styleUrls: ['./custom-input-time.component.scss']
})
export class CustomInputTimeComponent implements OnInit, OnChanges {

    @Input() label: string;
    @Input() labelClass: string;
    @Input() result: any;
    @Input() disabled: boolean;
    @Input() checkbox: boolean;
    @Output() resultChange = new EventEmitter<string>();
    hours: string;
    minutes: string;

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (!this.result) {
            delete this.hours;
            delete this.minutes;
        } else {
            this.parseTime(this.result);

        }
    }

    calculateResult() {
        let hours = parseInt(this.hours, 10) || 0;
        let minutes = parseInt(this.minutes, 10) || 0;
        if (hours > 24) {
            hours = 24;
        }
        if (minutes > 59) {
            minutes = 59;
        }
        if (hours === 24 && minutes > 0) {
            minutes = 0;
        }

        this.result = hours * 60 + minutes;
        this.minutes = minutes.toString();
        this.hours = hours.toString();
        this.formatTime();
        this.cd.markForCheck();
        this.resultChange.emit(this.result);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.result !== undefined) {
            this.parseTime(changes.result.currentValue);
        }
    }

    private parseTime(result: any) {
        this.hours = Math.floor(this.result / 60).toString();
        this.minutes = (this.result % 60).toString();
        this.formatTime();
    }

    private formatTime() {
        if (this.minutes.length === 1) {
            this.minutes = '0' + this.minutes;
        }
        if (this.hours.length === 1) {
            this.hours = '0' + this.hours;
        }
    }
}
